import { useCallback, useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { CartContext } from '../components/context/CartContext';
import useFireGtagEvent from './useFireGtagEvent';

export default function useCheckout() {
    const [startCheckout, setStartCheckout] = useState(false);
    const {
        checkoutData,
    } = useContext(CartContext);
    const navigate = useNavigate();
    const fireGA4Event = useFireGtagEvent();
    const fetchWebUrl = useCallback(() => {
        if (checkoutData?.webUrl) {
            if (checkoutData.LineItems?.length > 0) {
                // Fire the `begin_checkout` event
                fireGA4Event('begin_checkout', {
                    value: checkoutData.totalPrice,
                    currency: checkoutData.currencyCode,
                    items: checkoutData.LineItems.map((lineItem) => ({
                        item_id: lineItem.id,
                        item_name: lineItem.title,
                        quantity: lineItem.currentQuantity,
                        price: lineItem.totalUnitPrice,
                    })),
                });
            }
            // eslint-disable-next-line no-undef
            window.location.assign(checkoutData.webUrl);
        } else {
            navigate('/shoppingcart.asp');
        }
    }, [navigate, checkoutData]);
    useEffect(() => {
        if (startCheckout) {
            fetchWebUrl();
            setStartCheckout(false);
        }
    }, [fetchWebUrl, startCheckout]);
    return {
        startCheckout,
        setStartCheckout,
    };
}